import i18n from "i18next";
import { initReactI18next } from "react-i18next";



import enTranslation from "./en/translation.json";
import arTranslation from "./ar/translation.json";
import ckbTranslation from "./ckb/translation.json";


i18n.use(initReactI18next).init({
    resources: {
        en: { translation: enTranslation },
        ckb: { translation: ckbTranslation },
        ar: { translation: arTranslation },
    },
    lng: localStorage.getItem("lang") || "ckb", // Default language
    fallbackLng: "en",

    interpolation: {
        escapeValue: false, // React already escapes values
    },
    react: {
        useSuspense: true,   // <-- see next section
    },
});

export default i18n;